import React, { Component, useEffect, useState } from "react";
import {FaSearch} from 'react-icons/fa'
import { NavLink } from "react-router-dom";

const URL_API = 'https://api.jikan.moe/v4/anime';



const AnimeCard = ({res}) =>{
    const genre = res.genres;


    
    return(
       
        <NavLink to="/view" className="rounded-2xl flex select-none bg-gray-800 hover:bg-gray-700">
            <div className="w-24 rounded-2xl items-center flex">
                <img src={res.images.jpg.image_url} alt="" className="w-20 rounded-2xl object-contain rounded-tr-none"/>
            </div>
            <div className="p-4 text-start pl-4 font-normal w-full rounded-tl-2xl ">
                <div className="flex gap-2 items-baseline justify-between">
                    <div className="text-lg line-clamp-2 leading-5">
                    {res.title}
                    </div>
                    <div className="bg-[#FFD369] hover:bg-gray-800 hover:text-gray-200 select-none text-gray-800 rounded-lg text-xs px-2">
                    {res.score}
                    </div>
                </div>
                
                <div className="flex mt-1">
                    {genre.map((x)=> (
                        <div className="bg-[#096BDB] select-none mx-1 rounded-xl px-2 hover:bg-gray-800 hover:text-gray-200 line-clamp-1 text-xs" key={x.name}>{x.name}</div>
                    ))}
                </div>
                <div className="flex flex-row mt-1">
                    {console.log(res.season)}
                    {
                        

                         res.season != null ? 
                        (
                            <div className="bg-red-700 select-none mx-1 rounded-xl px-2 hover:bg-gray-800 hover:text-gray-200 line-clamp-1 text-xs">
                                {res.season}
                            </div>
                        ) : (
                            <></>
                        )
                    }

                    {
                         res.type != null ? 
                        (
                            <div className="bg-red-700 select-none mx-1 rounded-xl px-2 hover:bg-gray-800 hover:text-gray-200 line-clamp-1 text-xs">
                                {res.type}
                            </div>
                        ) : (
                            <></>
                        )
                    }
                    
                </div>
            </div>
        </NavLink>
    )
}


const AnimeList = () => {

    const [searchRes,setSearch] = useState([]);
    const [searchTerm,setSearchTerm] = useState([]);

   
    const handleKeydown = (event) => {
        if(event.key == 'Enter'){
            searchAnimes(searchTerm);
        }
    }


    const searchAnimes = async (name) =>{
    const response = await fetch(`${URL_API}?q=${name}`);
    const data = await response.json();
    
    setSearch(data.data);
    }

    useEffect(() => {
    }, [])

    return (
        <div className="m-5 col-span-4">
            <div className="flex flex-col">
                <div className="bg-[#1E1F25] border-[rgb(48,54,68)] border-[0.00625rem] py-5 mb-5 flex justify-center rounded-xl items-center gap-2">
                    <div className="rounded-lg ">
                        <input type="text"
                        placeholder="Search.."
                        value={searchTerm}  
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={handleKeydown}
                        // onSubmit={()=> searchAnimes(searchTerm)}
                        className="bg-[#22242C] rounded-3xl px-3 py-2 w-64 "/>
                    </div>
                    <div className="p-3 bg-[#22242C] rounded-full" onClick={()=> searchAnimes(searchTerm)}>
                        <FaSearch></FaSearch>
                    </div>
                </div>
                    
                    {
                        searchRes?.length > 0
                        ? (
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 text-white text-sm text-center font-bold leading-6 bg-stripes-fuchsia rounded-lg lg:max-h-[80vh] overflow-auto scroll-dark p-2 rounded-lg">
                        
                        {searchRes.map((anime) => (
                            <AnimeCard res={anime} />
                            ))}
                        </div>
                        ) : 
                        (
                        <div className="flex justify-center h-screen">
                        <div className="flex justify-center items-center bg-[#1E1F25] border-[rgb(48,54,68)] border-[0.00625rem] h-16 w-64 text-center rounded-xl  lg:max-h-[80vh]">
                            {
                                searchTerm == '' ?
                                (
                                        <>
                                        Input what you want to search
                                        </>
                                ): (
                                        <>
                                        Loading 
                                        {
                                            
                                            searchRes?.length == 0
                                            ?
                                            (
                                                <>..</>
                                            ):(
                                                <> Failed, Not Found</>
                                            )
                                        }
                                        </>
                                )
                            }</div>
                        </div>
                        )
                    }

                
            </div>
        </div>
    );
}


export default AnimeList;
// module.exports = {
    //     AnimePopular : AnimePopular,
    //     AnimeCard: AnimeCard
    // }